import { RawTemplatePararameter } from "../typings/RawTemplateParameter";

export class TemplateParameter {
  constructor(private rawData: RawTemplatePararameter) {}

  public get id(): string {
    return this.rawData._id;
  }

  public get parameter(): string {
    return this.rawData.parameter;
  }
}
